// extracted by mini-css-extract-plugin
export var label = "Tabs-module--label--6b464";
export var labels = "Tabs-module--labels--03a44";
export var tabs = "Tabs-module--tabs--7278c";